import { apiFetch } from "../utils/apiFetch";
import { API_BASE_CLIENT as API_BASE } from "../config/vars";

export const fetchMyRestrictions = async (networkId = null) => {
    const q = networkId ? `?network_id=${encodeURIComponent(networkId)}` : "";
    const res = await apiFetch(`${API_BASE}/clients/me/restrictions${q}`);
    if (!res.ok) throw new Error("Не вдалося завантажити обмеження");
    return await res.json();
};

export const submitClientComplaint = async ({ headId, accusedClientId, comment, networkId }) => {
    const res = await apiFetch(`${API_BASE}/clients/me/complaints`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            head_id: headId || null,
            accused_client_id: accusedClientId || null,
            comment,
            network_id: networkId || null,
        }),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        const detail = err?.detail;
        const msg = typeof detail === "string"
            ? detail
            : detail?.message || "Не вдалося подати скаргу";
        throw new Error(msg);
    }
    return await res.json();
};
